import { Button, Input, Pagination, Popover, Row, Select, Tabs } from 'antd';
import { ReactComponent as ArrowDownIcon } from 'app/assets/img/arrow_down.svg';
import { ReactComponent as PaymentIcon } from 'app/assets/img/b2b.paymentMethod.svg';
import { ReactComponent as CalendarIcon } from 'app/assets/img/icon_datepicker.svg';
import { ReactComponent as LocationIcon } from 'app/assets/img/icon_location_sunworld.svg';
import { ReactComponent as TicketFormIcon } from 'app/assets/img/ticket-form.svg';
import { LoadingContainer } from 'app/components/LoadingContainer/Loadable';
import useWindowSize from 'app/hooks/useWindowSize';
import format from 'date-fns/format';
import en from 'date-fns/locale/en-US';
import vi from 'date-fns/locale/vi';
import * as _ from 'lodash';
import moment from 'moment';
import React, {
  memo,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import 'react-multi-carousel/lib/styles.css';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import {
  BP_TYPE,
  DEFAULT_LANGUAGE,
  DELIVER_TICKET_TYPE_CODE,
} from 'utils/constants';
import { formatNumber, renderReplaceText } from 'utils/helper';
import { UTC_OFFSET } from 'utils/hooks/useCountDown';
import { useCommonSlice } from 'utils/hooks/useReduceCommon';
import { useSearchParams } from 'utils/hooks/useSearchParams';
import { useGlobalFunction } from '../App/hooks/useGlobalFunction';
import { selectInfoUser, selectTranslations } from '../App/slice/selectors';
import { useCartNew } from '../Cart/hooks/useCartNew';
import { cartActions } from '../Cart/slice';
import { isUpdateSuccess } from '../Cart/slice/selectors';
import { GET_PARKS, useHomeSlice } from '../Home/slice';
import { selectIsLoadingPark, selectListPark } from '../Home/slice/selectors';
import DatePickerInput from './DatePickerInput';
import { FormItemTicket } from './FormItemTicket';
import ListPark from './Mobile/listPark';
import SwitchTypeTicket from './SwitchTypeTicket';
import TicketSkeleton from './TicketSkeleton';
import DialogCondition from './components/DialogCondition';
import DialogDetailShow from './components/DialogDetailShow';
import DialogWarning from './components/DialogWarning';
import EmptyBlock from './components/EmptyBlock';
import Header from './components/Header';
import SelectionListSkeleton from './components/SelectionListSkeleton';
import { CustomCheckBox, CustomRadioCatalog } from './components/helper';
import {
  GET_CATALOGS,
  GET_LIST_PAYMENT_METHOD,
  GET_NEW,
  GET_PROMOTION,
  GET_SHOWS,
  useCatalogSlice,
} from './slice';
import {
  selectGetListPaymentMethods,
  selectGetListShow,
  selectGetListTicketForms,
  selectIsLoading,
  selectIsLoadingPaymentMethod,
  selectListCatalog,
  selectListShow,
  selectOptionsGetShows,
  selectPaginator,
} from './slice/selectors';
import { CatalogWrapper } from './styled';

registerLocale('vi', vi);
registerLocale('en', en);
setDefaultLocale(DEFAULT_LANGUAGE);

const DIFF_WORKSTATION_ID = 'DIF' as const;

interface Props {}

export const LIST_TYPE = [
  {
    value: 1,
    label: 'b2b.text.intra-province-ticket',
  },
  {
    value: 2,
    label: 'b2b.text.out-of-province-ticket',
  },
  {
    value: 4,
    label: 'b2b.text.s4-ticket',
  },
];

export const LIST_OBJECT = [
  {
    value: 1,
    label: 'b2b.text.adult-ticket',
  },
  {
    value: 2,
    label: 'b2b.text.child-ticket',
  },
  {
    value: 4,
    label: 'b2b.text.senior-ticket',
  },
  {
    value: 6,
    label: 'b2b.txt.u25-ticket',
  },
];

export const LIST_TICKET = {
  '1': 'b2b.text.long-term-ticket',
  '0': 'b2b.text.short-term-ticket',
};
export const CustomPopoverContent = (
  valueType: any,
  onChangeType: any,
  valueObject: any,
  onChangeObject: any,
) => {
  const translations = useSelector(selectTranslations);

  const listType = LIST_TYPE.map(({ label, value }) => ({
    label: translations?.[label] ?? '',
    value,
  }));

  const listObject = LIST_OBJECT.map(({ label, value }) => ({
    label: translations?.[label] ?? '',
    value,
  }));

  return (
    <div className="popover-content" style={{ minWidth: 130, margin: 4 }}>
      <div style={{ fontWeight: 600 }}>
        {translations?.['b2b.text.filter-ticket-type'] ?? ''}
      </div>
      {CustomCheckBox(listType, valueType, onChangeType)}
      <div style={{ fontWeight: 600 }} className=" mt-2">
        {translations?.['b2b.text.filter-objects'] ?? ''}
      </div>
      {CustomCheckBox(listObject, valueObject, onChangeObject)}
    </div>
  );
};

export const Catalog = memo((props: Props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { locale } = useGlobalFunction();
  const { insertUrlParam, removeUrlParameter } = useSearchParams();
  useHomeSlice();
  const { actions: catalogActions } = useCatalogSlice();
  const { actions: commonActions } = useCommonSlice();
  const { onGetCart } = useCartNew();
  const loading = useSelector(selectIsLoading);
  const getListShow = useSelector(selectGetListShow);
  const listPark = useSelector(selectListPark);
  const isLoadingPark = useSelector(selectIsLoadingPark);
  const listShow = useSelector(selectListShow);
  const translations = useSelector(selectTranslations);
  const optionsGetShows = useSelector(selectOptionsGetShows);
  const listCatalog = useSelector(selectListCatalog);
  const isUpdateCart = useSelector(isUpdateSuccess);
  const paginator = useSelector(selectPaginator);
  let listPaymentMethodReducer = useSelector(selectGetListPaymentMethods);
  const isLoadingPaymentMethod = useSelector(selectIsLoadingPaymentMethod);
  let listTicketFormReducer = useSelector(selectGetListTicketForms);
  const [parkId, setParkId] = useState<any>(undefined);
  const [paymentMethodId, setPaymentMethodId] = useState<number | undefined>(
    undefined,
  );
  const [ticketFormId, setTicketFormId] = useState<number | undefined>(
    undefined,
  );
  const [startDate, setStateDate] = useState(new Date());
  const [endDate, setEndDate] = useState(
    new Date(moment().add(90, 'days').format('YYYY-MM-DD')),
  );
  const [date, setDate] = useState<string | undefined>(undefined);
  const [time, setTime] = useState<string | undefined>(undefined);
  const [showSelected, setShowSelected] = useState<any | undefined>(undefined);
  const [isShowDialogCondition, setIsShowDialogCondition] = useState(false);
  const [valueType, setValueType] = useState<any>([]);
  const [valueObject, setValueObject] = useState<any>([]);
  const [valueTicket, setValueTicket] = useState<number>(0);
  const [listParkCustom, setListParkCustom] = useState<any>([]);
  const [listPaymentMethod, setListPaymentMethod] = useState<any>([]);
  const [listTicketForm, setListTicketForm] = useState<any>([]);
  const [listCatalogCustom, setListCatalogCustom] = useState<any>([]);
  const [loadingPage, setLoadingPage] = useState<any>(false);
  const [valueTab, setValueTab] = useState<any>('All');
  const [isShowDialogDetailShow, setIsShowDialogDetailShow] = useState(false);
  const [isShowDialogWarning, setIsShowDialogWarning] = useState(false);
  const [detailShow, setDataDetailShow] = useState<any>(null);
  const [page, setPage] = useState(1);
  const [newFilter, setNewFilter] = useState(false);
  const [messageWarning, setMessageWarning] = useState<any>('');
  const [partner] = useState<any>(null);
  const [allocatedDebt] = useState<number | null>(null);
  const { onOpenDialogNoti, onCloseDialogNoti } = useGlobalFunction();
  const { device } = useWindowSize();
  const filterContainer = useRef<HTMLDivElement>(null);
  const ticketTypeFilterContainer = useRef<HTMLDivElement>(null);
  const isNeedGetNewShowData = useRef(false);

  const infoUser = useSelector(selectInfoUser);

  const isShowTag = useMemo(() => {
    const bp = partner ?? infoUser?.businessPartner;
    return !!bp?.bpLongTerm && !!bp?.allowBuyShortTerm;
  }, [partner, infoUser?.businessPartner]);
  const isProxyBuyer =
    infoUser?.businessPartner?.bpType === BP_TYPE.PROXY_BUYER;
  const newArr = [
    {
      id: 'All',
      value: 'All',
      key: 'All',
      name: translations ? translations['b2b.text.all'] : '',
      label: translations ? translations['b2b.text.all'] : '',
    },
  ];
  const isMobile = window.innerWidth < 1200;

  const onCloseDialogCondition = useCallback(() => {
    setShowSelected(undefined);
    setIsShowDialogCondition(false);
  }, []);

  useEffect(() => {
    dispatch(GET_NEW());
    dispatch(GET_PROMOTION());
    dispatch(
      GET_LIST_PAYMENT_METHOD({
        ticketType: sessionStorage.getItem('ticketType'),
      }),
    );
    dispatch(
      GET_PARKS({
        checkPermission: true,
      }),
    );
    isNeedGetNewShowData.current = true;
  }, []);
  useEffect(() => {
    const search = new URLSearchParams(location.search);
    const park = search.get('park');
    const dateFrom = search.get('startDate');
    const dateTo = search.get('endDate');
    const isDateFromValid = moment(dateFrom, 'YYYY-MM-DD', true).isValid();
    const isDateToValid = moment(dateTo, 'YYYY-MM-DD', true).isValid();
    if (park && dateFrom && dateTo && isDateFromValid && isDateToValid) {
      const parkArr = park.split(',');
      setParkId(parkArr);
      const numberArray = parkArr.map(str => parseInt(str, 10));
      setParkId(numberArray);
      const dateFromUrl = new Date(dateFrom);
      const dateToUrl = new Date(dateTo);
      const currentDateTemp = new Date();
      const formattedCurrntDate = format(currentDateTemp, 'yyyy-MM-dd');
      const currentDate = new Date(formattedCurrntDate);
      const dateStart = dateFromUrl <= currentDate ? currentDate : dateFromUrl;
      setStateDate(dateStart);
      setEndDate(dateToUrl <= dateStart ? dateStart : dateToUrl);
    }
  }, [location]);

  useEffect(() => {
    if (startDate) insertUrlParam('startDate', format(startDate, 'yyyy-MM-dd'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate]);

  useEffect(() => {
    if (endDate) insertUrlParam('endDate', format(endDate, 'yyyy-MM-dd'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endDate]);

  useEffect(() => {
    if (parkId?.length) {
      insertUrlParam('park', parkId.join(','));
    } else {
      removeUrlParameter('park');
    }
  }, [parkId]);

  useEffect(() => {
    if (isLoadingPark) return;
    if (listPark?.length) {
      const listParkCustomTemp = listPark
        .map(item => ({
          ...item,
          value: item.id,
          label: item.name,
        }))
        .sort((a, b) => (a.workstationId === DIFF_WORKSTATION_ID ? -1 : 1));
      setListParkCustom(listParkCustomTemp);
      setParkId(
        listParkCustomTemp?.[0]?.workstationId === DIFF_WORKSTATION_ID
          ? [listParkCustomTemp?.[0]?.id]
          : [],
      );
    }
  }, [listPark, isLoadingPark]);
  useEffect(() => {
    if (listShow?.length) {
      setNewFilter(false);
    }
  }, [listShow]);

  useEffect(() => {
    if (isLoadingPaymentMethod) return;
    if (listPaymentMethodReducer?.length > 0) {
      const findDeposite = listPaymentMethodReducer.find(
        (item: any) => item?.default === true,
      );
      if (findDeposite) {
        setPaymentMethodId(findDeposite.id);
      } else {
        setPaymentMethodId(listPaymentMethodReducer[0].id);
      }
      const _listPaymentMethod = listPaymentMethodReducer.map((item: any) => ({
        id: item.id,
        name: item?.name || item?.code,
        label: item?.name || item?.code,
        value: item.id,
        detail: item,
      }));
      setListPaymentMethod(_listPaymentMethod);
    }
  }, [listPaymentMethodReducer, isLoadingPaymentMethod]);

  useEffect(() => {
    if (!listTicketFormReducer?.length) return;

    const canBuyPaperTicket: boolean = (() => {
      return !!infoUser?.businessPartner?.allowBuyPaperTicket;
    })();

    const listTicketForm = canBuyPaperTicket
      ? listTicketFormReducer
      : listTicketFormReducer.filter(
          i => i?.code !== DELIVER_TICKET_TYPE_CODE.PAPER_TICKET,
        );

    if (!listTicketForm?.some(i => i?.id === ticketFormId)) {
      const findEVoucher = listTicketForm.find(
        (item: any) => _.isEmpty(item?.code) || item?.id === 27964,
      );

      setTicketFormId(!!findEVoucher ? findEVoucher.id : listTicketForm[0].id);
    }
    setListTicketForm(
      listTicketForm.map((item: any) => ({
        id: item.id,
        name: item?.name || item?.code,
        label: item?.name || item?.code,
        value: item.id,
        detail: item,
      })),
    );
  }, [
    ticketFormId,
    infoUser?.businessPartner?.allowBuyPaperTicket,
    isProxyBuyer,
    listTicketFormReducer,
  ]);

  useEffect(() => {
    if (startDate && endDate) {
      dispatch(
        catalogActions.onsSetOptionsGetShows({
          park: parkId && parkId?.length ? parkId.toString() : null,
          dateFrom: format(startDate, 'yyyy-MM-dd'),
          dateTo: format(endDate, 'yyyy-MM-dd'),
          date: date || null,
          time: time || null,
          areaType: valueType.toString() || null,
          ageType: valueObject.toString() || null,
          ticketType: !!isShowTag ? `${valueTicket}` : null,
          catalog: valueTab || null,
          limit: 10,
          page: page,
        }),
      );
      setNewFilter(true);
    }
  }, [
    parkId,
    date,
    time,
    startDate,
    endDate,
    valueType,
    valueObject,
    valueTab,
    dispatch,
    catalogActions,
    page,
    valueTicket,
    isShowTag,
  ]);

  useEffect(() => {
    if (
      !optionsGetShows.dateFrom ||
      !optionsGetShows.dateTo ||
      isLoadingPaymentMethod ||
      _.isEmpty(listPaymentMethod)
    )
      return;
    isNeedGetNewShowData.current = true;
    dispatch(
      GET_SHOWS({
        ..._.omit(optionsGetShows, ['groupCode']),
        onSuccess: () => {
          isNeedGetNewShowData.current = false;
        },
        onFailed: () => {
          isNeedGetNewShowData.current = false;
        },
      }),
    );
  }, [optionsGetShows, dispatch, isLoadingPaymentMethod, listPaymentMethod]);

  useEffect(() => {
    dispatch(GET_CATALOGS(''));
    onGetCart(true);
  }, [dispatch, onGetCart]);

  useEffect(() => {
    if (listCatalog?.length) {
      const arr = listCatalog.map(item => ({
        ...item,
        key: item.id,
        value: item.id,
        label: item?.name,
      }));
      setListCatalogCustom([...newArr, ...arr]);
    } else {
      setListCatalogCustom([]);
    }
  }, [listCatalog, translations]);
  useEffect(() => {
    if (isUpdateCart) {
      setLoadingPage(false);
      dispatch(commonActions.fetchHiddenLoadingPage());
    }
  }, [isUpdateCart]);

  const onChangeType = (checkedValues: any) => {
    setPage(1);
    setValueType(checkedValues);
    // isNeedGetNewShowData.current = true;
  };
  const onChangeObject = (checkedValues: any) => {
    setPage(1);
    setValueObject(checkedValues);
    // isNeedGetNewShowData.current = true;
  };

  useEffect(() => {
    if (
      !!infoUser &&
      !infoUser?.businessPartner?.bpLongTerm &&
      !infoUser?.businessPartner?.allowBuyShortTerm
    ) {
      removeUrlParameter('ticketType');
    }
  }, [infoUser]);

  const onChangeTicket = (value?: number) => {
    setPage(1);

    if (typeof value === 'number') {
      sessionStorage.setItem('ticketType', `${value}`);
      setValueTicket(value);
    } else {
      sessionStorage.setItem('ticketType', `${valueTicket === 1 ? 0 : 1}`);
      setValueTicket(prev => {
        return prev === 1 ? 0 : 1;
      });
    }
    onGetCart(true);

    // isNeedGetNewShowData.current = true;
  };
  const onChangePark = (checkedValues: any) => {
    // setValuePark(checkedValues);
    // isNeedGetNewShowData.current = true;
    setPage(1);
    setParkId(checkedValues);
  };

  const onChangePaymentMethod = (e: any) => {
    const payment = listPaymentMethod.find(
      val => val.id == e.target.value,
    )?.detail;

    const hourFrom = listPaymentMethod?.find(val => val.id == e.target.value)
      ?.detail?.validFrom;
    const hourTo = listPaymentMethod?.find(val => val.id == e.target.value)
      ?.detail?.validTo;

    if (hourFrom && hourTo) {
      const parseHourFrom = moment(hourFrom, 'HH:mm').format('HH');
      const parseHourTo = moment(hourTo, 'HH:mm').format('HH');
      const parseMinuteFrom = moment(hourFrom, 'HH:mm').format('mm');
      const parseMinuteTo = moment(hourTo, 'HH:mm').format('mm');
      const currentDate = moment().utcOffset(UTC_OFFSET);
      const currentHour = currentDate.hours() + currentDate.minutes() / 60;

      const isValidHour =
        currentHour >=
          parseInt(parseHourFrom, 10) + parseInt(parseMinuteFrom, 10) / 60 &&
        currentHour <
          parseInt(parseHourTo, 10) + parseInt(parseMinuteTo, 10) / 60;
      if (!isValidHour) {
        onOpenDialogNoti({
          type: 'ERROR',
          title: '',
          content: translations?.['b2b.txt.payment_notice_2']?.replace(
            '${payment}',
            payment?.name,
          ),
          isShow: true,
          buttons: [],
          maskClosable: false,
          closable: true,
          onCloseDialog: onCloseDialogNoti,
        });
        return;
      }
    }

    const value = e.target.value;
    setPaymentMethodId(value);
  };
  const onChangeTicketForm = (e: any) => {
    const value = e.target.value;
    setTicketFormId(value);
  };

  const onChangeTab = (key: any) => {
    setPage(1);
    setValueTab(key);
    // isNeedGetNewShowData.current = true;
  };

  const onCloseDialogDetailShow = () => {
    setIsShowDialogDetailShow(false);
    setDataDetailShow(null);
  };
  const seeDetailShow = item => {
    setIsShowDialogDetailShow(true);
    setDataDetailShow(item);
  };
  const onChangePagination = item => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => {
      setPage(item);
    }, 150);
  };
  const resetErr = useCallback(
    () => dispatch(cartActions.onResetError()),
    [cartActions, dispatch],
  );
  const onCloseDialogWarning = () => {
    setIsShowDialogWarning(false);
    resetErr();
  };
  const getValueTypeFilter = () => {
    let text = '';
    const arrObject = LIST_OBJECT.filter(item =>
      valueObject.includes(item.value),
    );
    const arrType = LIST_TYPE.filter(item => valueType.includes(item.value));

    const arrGroup: any = [...arrObject, ...arrType];
    const textGroup = arrGroup.map((i: any) => translations?.[i?.label] ?? '');
    text = textGroup.toString();
    return text;
  };

  const PaymentNoticeTradeDiscount = () => {
    const paymentNotice = useMemo(() => {
      const detail = listPaymentMethod?.find(
        val => val.id === paymentMethodId,
      )?.detail;
      const commission = detail?.commission;
      if (!commission || isProxyBuyer) return '';
      const formattedAmount = `${formatNumber(
        detail.code === 'CommissionMou'
          ? commission?.availableAmount || 0
          : commission?.availableAmount || 0,
      ).replaceAll(',', '.')}đ`;
      const formattedDate = commission?.validTo
        ? moment(commission.validTo.toString(), 'YYYYMMDD').format('DD/MM/YYYY')
        : '';
      return (
        translations?.[
          detail.code === 'CommissionMou'
            ? 'b2b.txt.payment_notice_trade_discount'
            : 'b2b.txt.payment_notice_trade_discount'
        ]
          ?.replace('${X}', formattedAmount)
          ?.replace('${end_date}', formattedDate) || ''
      );
    }, [paymentMethodId]);
    if (!paymentNotice) return null;
    return <i style={{ fontSize: 14, color: '#000000' }}>{paymentNotice}</i>;
  };
  const paymentDetail = listPaymentMethod?.find(
    val => String(val.id) === String(paymentMethodId),
  )?.detail;
  const hasCatalog = !!listCatalogCustom?.length;
  const isInitialLoading = loading && !hasCatalog;
  const hasShow = !!listShow?.length;
  const isEmptyAll = !hasShow;
  const showEmpty = getListShow && (!hasCatalog || isEmptyAll);
  const isFetching = isNeedGetNewShowData.current;
  return (
    <CatalogWrapper id="show" className="main">
      <div className="catalogShow">
        <div
          className="container custom-container"
          style={{ padding: '16px 16px 42px' }}
        >
          <div className="row">
            <div className={`col-md-${isMobile ? 12 : 3}`}>
              <div className="box-left">
                {isMobile ? (
                  <ListPark
                    parkId={parkId}
                    listParkCustom={listParkCustom}
                    onChangePark={onChangePark}
                    translations={translations}
                  />
                ) : (
                  <>
                    <div className="list-park">
                      <div className="d-flex align-items-center mb-0">
                        <div className="--icon mb-1">
                          <LocationIcon />
                        </div>
                        <div className="header-park">
                          {translations
                            ? translations['b2b.text.sunworld-park']
                            : ''}
                        </div>
                      </div>

                      {isLoadingPark ? (
                        <SelectionListSkeleton />
                      ) : listParkCustom?.length && parkId ? (
                        CustomCheckBox(listParkCustom, parkId, onChangePark)
                      ) : null}
                    </div>
                  </>
                )}

                <div className="list-payment-method">
                  <div className="d-flex align-items-center mb-0 w-100">
                    <div className="--icon mb-1">
                      <PaymentIcon />
                    </div>
                    <div className="header-park">
                      {translations
                        ? translations['b2b.txt.paymentMethod']
                        : ''}
                    </div>
                  </div>
                  {isLoadingPaymentMethod ? (
                    <SelectionListSkeleton type="radio" />
                  ) : listPaymentMethod?.length && paymentMethodId ? (
                    CustomRadioCatalog(
                      listPaymentMethod,
                      paymentMethodId,
                      onChangePaymentMethod,
                    )
                  ) : null}
                  {paymentDetail?.validFrom && (
                    <i style={{ fontSize: 14, color: '#000000' }}>
                      {renderReplaceText(
                        translations?.['b2b.txt.payment_notice_1'],
                        {
                          payment: paymentDetail?.name,
                          hour_from: paymentDetail?.validFrom,
                          hour_to: paymentDetail?.validTo,
                        },
                      )}
                    </i>
                  )}
                  <PaymentNoticeTradeDiscount />
                </div>

                {listTicketForm?.length > 0 && ticketFormId && (
                  <div className="list-payment-method">
                    <div className="d-flex align-items-center mb-0">
                      <div className="--icon mb-1">
                        <TicketFormIcon />
                      </div>
                      <div className="header-park">
                        {translations
                          ? translations['b2b.txt.ticket-form']
                          : ''}
                      </div>
                    </div>
                    {CustomRadioCatalog(
                      listTicketForm,
                      ticketFormId,
                      onChangeTicketForm,
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className={`ticketRight col-md-${isMobile ? 12 : 9}`}>
              <div className="--left product-ticket catalogTicketHead pe-0">
                <PopupContainer ref={ticketTypeFilterContainer} />
                <div
                  className="ticketHead"
                  style={{
                    display: 'flex',
                  }}
                >
                  <div
                    className="d-flex"
                    style={{
                      justifyContent:
                        device !== 'desktop' ? 'space-between' : 'flex-start',
                      flex: 1,
                    }}
                  >
                    {/* <div className="--title">DANH SÁCH VÉ</div> */}
                    {isMobile ? (
                      <StyledSelect
                        options={listCatalogCustom}
                        onChange={onChangeTab}
                        value={valueTab}
                        suffixIcon={<ArrowDownIcon />}
                        getPopupContainer={() =>
                          ticketTypeFilterContainer.current!
                        }
                      ></StyledSelect>
                    ) : null}
                    <div className="d-flex align-items-center">
                      <div className="--currentSelectedDate d-flex align-items-center">
                        <DatePicker
                          dateFormat="EEE (dd/MM/yyyy)"
                          minDate={new Date()}
                          locale={locale}
                          // selected={startDate}
                          popperPlacement="top"
                          customInput={
                            isMobile ? (
                              <CalendarIcon style={{ flexShrink: 0 }} />
                            ) : (
                              <DatePickerInput className="--custom-input-calender" />
                            )
                          }
                          withPortal
                          selectsRange
                          startDate={startDate}
                          endDate={endDate}
                          onChange={value => {
                            const [start, end] = value as Date[];
                            setStateDate(start);
                            setEndDate(end);
                            setDate(undefined);
                            setTime(undefined);
                            setPage(1);
                            // isNeedGetNewShowData.current = true;
                          }}
                          shouldCloseOnSelect={true}
                          renderCustomHeader={props => <Header {...props} />}
                          tabIndex={-1}
                          onClickOutside={() =>
                            setEndDate(prev => (!prev ? startDate : prev))
                          }
                        />
                      </div>
                      <PopupContainer ref={filterContainer} />
                      <StyledPopover
                        placement="bottomLeft"
                        content={CustomPopoverContent(
                          valueType,
                          onChangeType,
                          valueObject,
                          onChangeObject,
                        )}
                        trigger="click"
                        overlayInnerStyle={{
                          borderRadius: '20px',
                        }}
                        getPopupContainer={() => filterContainer.current!}
                      >
                        <StyledButton>
                          <StyledInputFilter
                            value={getValueTypeFilter()}
                            readOnly
                            placeholder={
                              translations ? translations['b2c.txt.filter'] : ''
                            }
                          />
                          <img src="/static/img/icon_filter.svg" />
                        </StyledButton>
                      </StyledPopover>
                    </div>
                  </div>
                  {!!isShowTag && (
                    <div
                      style={{
                        marginLeft: '8px',
                      }}
                    >
                      <SwitchTypeTicket
                        isShow={!!isShowTag}
                        onChangeTicket={onChangeTicket}
                        valueTicket={valueTicket}
                      />
                    </div>
                  )}
                </div>
                <LoadingContainer loading={isInitialLoading} minHeight="70vh">
                  <div className="list_all_ticket">
                    {hasCatalog ? (
                      <Tabs
                        defaultActiveKey={valueTab}
                        onChange={onChangeTab}
                        className="custom-tab"
                        destroyInactiveTabPane
                      >
                        {listCatalogCustom.map(item => (
                          <Tabs.TabPane tab={item.name} key={item.id}>
                            {isFetching ? (
                              <TicketSkeleton />
                            ) : hasShow ? (
                              <>
                                <Row>
                                  {listShow.map((ii: any) => (
                                    <React.Fragment key={ii.id}>
                                      <FormItemTicket
                                        partner={partner}
                                        dataItem={ii}
                                        startDate={startDate}
                                        endDate={endDate}
                                        translations={translations}
                                        seeDetailShow={seeDetailShow}
                                        newFilter={newFilter}
                                        paymentMethodId={paymentMethodId}
                                        setIsShowDialogWarning={
                                          setIsShowDialogWarning
                                        }
                                        setMessageWarning={setMessageWarning}
                                        isLoading={loadingPage}
                                        ticketFormId={ticketFormId}
                                        setLoadingPage={setLoadingPage}
                                        allocatedDebt={allocatedDebt}
                                        valueTicket={valueTicket}
                                      />
                                    </React.Fragment>
                                  ))}
                                </Row>
                                <div className="--show-more d-flex">
                                  <Pagination
                                    defaultCurrent={1}
                                    current={
                                      _.isInteger(paginator?.current)
                                        ? paginator.current
                                        : 1
                                    }
                                    total={paginator?.totalCount}
                                    onChange={
                                      paginator?.totalCount > 10
                                        ? onChangePagination
                                        : undefined
                                    }
                                  />
                                </div>
                              </>
                            ) : (
                              <EmptyBlock translations={translations} />
                            )}
                          </Tabs.TabPane>
                        ))}
                      </Tabs>
                    ) : showEmpty ? (
                      <EmptyBlock translations={translations} />
                    ) : null}
                  </div>
                </LoadingContainer>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isShowDialogCondition && (
        <DialogCondition
          title={showSelected?.name}
          content={showSelected?.content}
          isShow={isShowDialogCondition}
          onCloseDialog={onCloseDialogCondition}
        />
      )}
      {isShowDialogDetailShow && (
        <DialogDetailShow
          isShow={isShowDialogDetailShow}
          onCloseDialog={onCloseDialogDetailShow}
          detailShow={detailShow}
        />
      )}
      {isShowDialogWarning && (
        <DialogWarning
          open={isShowDialogWarning}
          onClose={onCloseDialogWarning}
          message={messageWarning}
        />
      )}
    </CatalogWrapper>
  );
});
export const StyledButton = styled(Button)`
  box-shadow: none !important;
  height: 45px;
  width: 166px;
  border: 1px solid #d9d9d9;
  border-radius: 10px;
  margin-left: 20px;
  &:focus,
  &:active,
  &:hover {
    border: 1px solid #d9d9d9;
    box-shadow: none !important;
  }

  &::after {
    content: none !important;
  }
  @media (max-width: 1200px) {
    height: 41px;
    width: 41px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 8px;
  }
`;
export const StyledPopover = styled(Popover)`
  .ant-popover-inner {
    background-color: lightblue !important;
  }
`;
export const StyledInputFilter = styled(Input)`
  height: 43px;
  border: none;
  margin-top: -4px;
  width: 120px;
  padding-left: 0px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  .ant-input {
  }
  &:focus,
  &:active,
  &:hover {
    border: none !important;
    box-shadow: none !important;
  }
  @media (max-width: 1200px) {
    display: none;
  }
`;
export const StyledSelect = styled(Select)`
  width: 180px;
  /* position: absolute;
  left: 50px; */
  text-align: center;
  /* @media (max-width: 480px) {
    left: 30px;
  } */
  .ant-select-selection-placeholder {
    color: #808080;
  }
  .ant-select-selection-item {
    font-weight: 700;
  }
  &.ant-select-disabled {
    .ant-select-selector {
      background-color: #ffffff !important;
    }
  }
  &.ant-select {
    .ant-select-selector {
      border: solid 1px #ededed;
      height: 40px;
      align-items: center;
      padding-left: 2px;
      border-radius: 10px !important;
    }
    .ant-select-disabled {
      background: #ffffff;
    }
    &:hover {
      .ant-select-selector {
        border-color: #ededed;
      }
    }
  }
`;

const PopupContainer = styled.div`
  & > div:first-child {
    z-index: 1;
  }
`;
